import React, { useState } from "react"
import * as styles from "./ProjectSpecifications.module.css"

const ProjectSpecifications = () => {
  const [activeIndex, setActiveIndex] = useState(null)

  const specifications = [
    {
      title: "Structure",
      items: [
        "RCC frame structure with masonry partitions",
        "Internal Masonry - Aerocon blocks or equivalent"
      ]
    },
    {
      title: "Floor Finishes",
      items: [
        "Living: Imported marble",
        "Kitchen: Granite flooring",
        "Bedrooms: Imported marble",
        "Sit Out: Granite matte flooring",
        "Utility: 2X2 Vitrified tiles of a reputed brand",
        "Toilets: Imported marble up to false ceiling height",
        "Powder Room: Imported marble"
      ]
    },
    {
      title: "Wall Finishes",
      items: [
        "Internal Walls & ceiling: Smooth putty finish with 2 coats of emulation paint of reputed brand over one coat of primer",
        "External Walls: Stone / Textured finish and 2 coats of exterior emulsion paint of reputed brand over one coat of primer"
      ]
    },
    {
      title: "Sanitary & Plumbing",
      items: [
        "Bedroom Toilets: Western Style, Porcelain EWC of Catalano / equivalent",
        "Wash Basin: Porcelain wash basins of Catalano / equivalent",
        "Bathrooms: Provided with shower cubicle plus rain shower and hand shower",
        "Overhead Showers: Will be of Hansgrohe / equivalent in all bathrooms",
        "Master Bedrooms: Will have rain shower",
        "Faucets: All faucets shall be CP, colour coordinated heavy body metal fittings of Fantini / equivalent",
        "Hot water connection shall be provided to the shower, wash basins, bathrooms and kitchen sink",
        "Plumbing: All external water supply lines & drainage lines shall be in PVC pipes internal water supply lines will be of concealed CPVC pipes"
      ]
    },
    {
      title: "Doors",
      items: [
        "Main Door: 8ft. Engineered frame doors with wooden veneer shutters",
        "Other Doors: 8ft. Engineered frame and shutters with natural wood veneer finish",
        "Internal Door Finish: Internal door shutters and frames shall be provided with a melamine matt finish",
        "Bedroom Doors: Shall have a height of 8ft."
      ]
    },
    {
      title: "Windows",
      items: [
        "Aluminum windows with mosquito mesh"
      ]
    },
    {
      title: "Electrical Wiring & Switches",
      items: [
        "3-phase supply with independent meters and phase change facility in each apartment",
        "Concealed electrical wiring Finolex cables or equivalent and sufficient points with schneider or equivalent modular switches",
        "False ceiling with LED lights provided",
        "Home automation in living, dinning area and all bedrooms",
        "Data points and CAT 6 cable for all bedrooms and living areas with networking option",
        "Heat pump for all apartments",
        "6-button touch panel in the living and dinning area",
        "A handy 4 button smart panel by the bedside"
      ]
    },
    {
      title: "Home Automation System",
      items: [
        "Main door intrusion detection",
        "Bathroom lighting fitted with motion sensor",
        "All bathroom air-conditioning with on / off control",
        "Fully Automated air-conditioning for living / dining area",
        "Gas leak Sensor",
        "Curtain control"
      ]
    },
    {
      title: "Power Backup",
      items: [
        "Backup power provided to the entire unit and common area lighting, pumps, motors, etc",
        "Generators have acoustic enclosures and an AMF panel with an automatic change-over switch"
      ]
    },
    {
      title: "Water Plant",
      items: [
        "A water purification plant provided for the supply of treated water to the units",
        "Rainwater harvesting percolation pits are provided"
      ]
    },
    {
      title: "Elevators/Lifts",
      items: [
        "Mitsubishi passenger elevators shall be provided with automatic doors"
      ]
    },
    {
      title: "Common Amenities and Facilities",
      items: [
        "SECURITY SYSTEM:",
        "Security cameras at the main gate, elevators, servant rooms, ground floor lobby area and all common areas including gymnasium",
        "Intercom facility connecting each apartment to the security room",
        "OTHER FACILITIES / AMENITIES:",
        "Gymnasium, Swimming Pool",
        "Integrated DTH system using TRIAX"
      ]
    }
  ]

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return (
    <section className={styles.specAccordion} id="project-specifications">
      <h2 className={styles.specTitle}>
        Project <span className={styles.cbr}>Specifications</span>
      </h2>

      {specifications.map((spec, index) => (
        <div key={index} className={styles.accordionItem}>
          <button
            className={`${styles.accordionHeader} ${activeIndex === index ? styles.active : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            {spec.title}
          </button>
          <div
            className={`${styles.accordionContent} ${activeIndex === index ? styles.open : ''}`}
            style={{
              maxHeight: activeIndex === index ? '1000px' : '0'
            }}
          >
            <ul>
              {spec.items.map((item, itemIndex) => (
                <li key={itemIndex}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </section>
  )
}

export default ProjectSpecifications
